import { ApiProperty } from '@nestjs/swagger';
import { OffsetPaginationResponseDto } from '@sphere/shared/domain';
import { ActivityCategoryResponseDto } from './activity-category.response';

export class ActivityCategoryListResponseDto extends OffsetPaginationResponseDto<ActivityCategoryResponseDto> {
  @ApiProperty({ type: () => [ActivityCategoryResponseDto] })
  declare data: ActivityCategoryResponseDto[];
}

